import React from 'react';
import { useTheme } from '../context/ThemeContext';

/**
 * App footer — shown at the bottom of every authenticated page (AppShell).
 * "Powered by HunterLabs Inc." with a theme-aware logo (white mark on dark,
 * black mark on light) linking to hunterlabs.solutions, plus the RMC2
 * Consultancy Corporation copyright linking to its site. Both links open in a
 * new tab. Theme-token styled (Rule 56) so it reads correctly in both modes.
 */
export default function AppFooter() {
  const { isDark } = useTheme();
  const hlabsLogo = isDark ? '/logo192-hlabs-white.png' : '/logo192-hlabs-black.png';

  return (
    <footer className="app-footer" role="contentinfo">
      <a
        className="app-footer-brand"
        href="https://hunterlabs.solutions/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Powered by HunterLabs Inc. — opens hunterlabs.solutions in a new tab"
      >
        <span className="app-footer-muted">Powered by</span>
        <img
          className="app-footer-logo"
          src={hlabsLogo}
          alt="HunterLabs Inc."
          width="18"
          height="18"
          onError={(e) => { e.currentTarget.style.display = 'none'; }}
        />
        <span className="app-footer-brand-name">HunterLabs Inc.</span>
      </a>

      <span className="app-footer-copy">
        Copyright © 2026{' '}
        <a
          className="app-footer-link"
          href="https://www.rmc2consultancycorp.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          RMC2 Consultancy Corporation
        </a>
        . All rights reserved.
      </span>
    </footer>
  );
}
